import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const PhotographicPrintTee = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.PhotographicPrintTee.itemName}
      name={SS23.tops.PhotographicPrintTee.itemName}
      price={SS23.tops.PhotographicPrintTee.itemPrice}
      fabric={SS23.tops.PhotographicPrintTee.itemFabric}
      src={SS23.tops.PhotographicPrintTee.sizeChart}
      divId={SS23.tops.PhotographicPrintTee.shopifyDivId}
      mainId={SS23.tops.PhotographicPrintTee.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.PhotographicPrintTee.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.PhotographicPrintTee.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default PhotographicPrintTee;
